export default {
  methods: {
    isEmptyObject(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    },
    toQueryString(data) {
      return Object
        .keys(data)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
        .join('&');
    },
    encodeDataToURL(data) {
      return Object
        .keys(data)
        .map(k => `${encodeURIComponent( encodeURIComponent(k) + '=' +encodeURIComponent(data[k]) ) }`)
        .join(`${encodeURIComponent('&')}`);
    },
    fetchUserData() {
      this.$http.get('/wp-admin/admin-ajax.php?action=app_get_user_data')
        .then(res => {
          if (res.data) {
            this.$store.commit('setUserData', { userData: res.data.user_data });
            // Check if user has address data
            if (this.$store.state.userData.address === null)  this.$store.commit('setEmptyAddress');
            // Check if user has invoice data
            if (this.$store.state.userData.invoice === null)  this.$store.commit('setEmptyInvoice');
            this.$store.commit('saveUserInSession');
          }
        })
        .catch()
    },
    async updateAddressData() {
      const addressData = {
        'address[company]' : this.$store.state.userData.address.company,
        'address[firstname]' : this.$store.state.userData.address.firstname,
        'address[lastname]' : this.$store.state.userData.address.lastname,
        'address[phone]' : this.$store.state.userData.address.phone,
        'address[street]' : this.$store.state.userData.address.street,
        'address[streetnumber]' : this.$store.state.userData.address.streetnumber,
        'address[apartamentnumber]' : this.$store.state.userData.address.apartamentnumber,
        'address[postcode]' : this.$store.state.userData.address.postcode,
        'address[city]': this.$store.state.userData.address.city,
        'address[country]' : this.$store.state.userData.address.country
      };
      const { data } = await this.$http.get(
        `/wp-admin/admin-ajax.php?action=update_user_profile_data&form_data=${ this.encodeDataToURL(addressData) }`);

      if (data === 0 || data.state === 'error') {
        throw new Error('Error when updating user address data')
      }
      return data
    },
    async updateInvoiceData() {
      const invoiceData = {
        'invoice[company]': this.$store.state.userData.invoice.company,
        'invoice[nip]': this.$store.state.userData.invoice.nip,
        'invoice[street]': this.$store.state.userData.invoice.street,
        'invoice[streetnumber]': this.$store.state.userData.invoice.streetnumber,
        'invoice[apartamentnumber]': this.$store.state.userData.invoice.apartamentnumber,
        'invoice[postcode]': this.$store.state.userData.invoice.postcode,
        'invoice[city]': this.$store.state.userData.invoice.city,
        'invoice[country]': this.$store.state.userData.invoice.country,
      };

      const { data } = await this.$http.get(
        `/wp-admin/admin-ajax.php?action=update_user_invoice_data&form_data=${ this.encodeDataToURL(invoiceData) }`);

      if (data === 0 || data.state === 'error') {
        throw new Error('Error when updating user invoice data')
      }
      return data
    }
  }
}
